import { Autocomplete, FormControl, InputLabel, OutlinedInput } from '@mui/material';
import { format } from 'date-fns';
import React from 'react';
export const TimePicker = (props) => {
    var _a;
    const options = getTimes(props.timeFormat, props.timeMinuteStep, props.value.time, props.minTime, props.maxTime);
    const value = (_a = options.find((option) => option.value === props.value.time)) !== null && _a !== void 0 ? _a : null;
    return (React.createElement(Autocomplete, { sx: Object.assign({ width: '100%', maxWidth: {
                xs: '100%',
                sm: props.fullWidth ? '100%' : 260,
            } }, props.sx), fullWidth: props.fullWidth, size: props.size, value: value, options: options, disabled: props.disabled, readOnly: props.readOnly, renderInput: (params) => {
            var _a;
            return (React.createElement(FormControl, { variant: 'outlined', fullWidth: props.fullWidth, size: params.size, required: props.required, error: props.error, disabled: params.disabled, sx: {
                    width: '100%',
                    '& label.MuiInputLabel-root': { paddingRight: 3 },
                } },
                props.label && (React.createElement(InputLabel, { variant: 'outlined', required: props.required, error: props.error, disabled: props.disabled }, props.label)),
                React.createElement(OutlinedInput, Object.assign({}, params.InputProps, { inputProps: props.tabIndex === -1
                        ? Object.assign(Object.assign({}, params.inputProps), { 'aria-label': props.label, tabIndex: -1 }) : Object.assign(Object.assign({}, params.inputProps), { 'aria-label': props.label }), label: props.label, fullWidth: props.fullWidth, size: params.size, required: props.required, error: props.error, disabled: params.disabled, "data-test": props['data-test'], autoFocus: (_a = props.autoFocus) !== null && _a !== void 0 ? _a : false, "aria-describedby": props.ariaDescribedBy }))));
        }, onChange: (event, option) => {
            const newTime = option === null || option === void 0 ? void 0 : option.value;
            props.onChange({ time: newTime });
        } }));
};
const oneSecondInMs = 1000;
const oneMinuteInMs = 60 * oneSecondInMs;
const oneHourInMs = 60 * oneMinuteInMs;
const oneDayInMs = 24 * oneHourInMs;
function getTimes(timeFormat = '24h', minuteStep = 30, selectedTime, minTime, maxTime) {
    const times = [];
    const stepInMs = minuteStep * oneMinuteInMs;
    for (let value = 0; value < oneDayInMs; value += stepInMs) {
        if (((minTime == null || value >= minTime) && (maxTime == null || value <= maxTime)) || value === selectedTime) {
            times.push({
                label: formatTime(value, timeFormat),
                value,
            });
        }
        if (selectedTime != null && selectedTime > value && selectedTime < value + stepInMs) {
            times.push({
                label: formatTime(value, timeFormat),
                value: selectedTime,
            });
        }
    }
    return times;
}
export function formatTime(value, timeFormat = '24h') {
    const dateZeroTime = new Date(2000, 1, 1).getTime();
    const date = new Date(dateZeroTime + value);
    const ms = date.getTime();
    const second = Math.floor((ms % oneMinuteInMs) / oneSecondInMs);
    const millisecond = Math.floor(ms % oneSecondInMs);
    let formatSuffix = '';
    if (millisecond > 0) {
        formatSuffix = ':ss.SSS';
    }
    else if (second > 0) {
        formatSuffix = ':ss';
    }
    if (timeFormat === '12h') {
        return format(date, 'hh:mm' + formatSuffix + ' a');
    }
    else {
        return format(date, 'HH:mm' + formatSuffix);
    }
}
